import React from 'react';
import './Banner.css';

import { Heading, Button } from '../../components'; // Importing reusable Heading and Button components

import { FaPhoneVolume } from 'react-icons/fa';



const Banner = () => {
  return (
    <section className="banner">
      <div className="content">
        
        {/* Heading component with dynamic props */}
        <Heading title={'Experience Reliable and Comfortable Taxi Services'} subTitle={'Book Your Ride'} linear sideHeading />

        <div className='taxi-call'>
          <div className='icon'><FaPhoneVolume /></div>
          <span>1234-567-890</span>
        </div>

        <Button link={'Booking'} title={'Book Ride'} />

      </div>
    </section>
  );
};

export default Banner;